import React from 'react';
import shape from '../../../images/shape/about-glassisom.png';

const About = () => {
    return (
        <section className="about">
            <div className="container">
                <div className="row">
                    
                    {/* Left */}
                    <div className="col-lg-6">
                        <div className="da-about-left">
                            <h2 className="title">
                                High-impact B2B <br />
                                conferences that <br />
                                drive innovation.
                            </h2>
                            <div className="img">
                                <img src={shape} alt="" />
                            </div>
                        </div>
                    </div>

                    {/* Right */}
                    <div className="col-lg-6">
                        <div className="da-about-right">
                            <p className="content">
                                ARO Events is a B2B conference firm that connects industry leaders,
                                corporations, government agencies, and investors across key sectors.
                            </p>

                            <p className="content">
                                We create future-focused conferences designed to foster meaningful
                                collaboration, spark innovation, and encourage the exchange of ideas
                                that lead to strategic growth.
                            </p>

                            <p className="content">
                                Our events serve as powerful platforms where bold thinking,
                                valuable partnerships, and transformative opportunities come together.
                            </p>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default About;
